import { Card, CardContent, Typography, Avatar, Divider, Box, Grid } from "@mui/material";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Email, Phone, Home, Person } from "@mui/icons-material";

const UserDetails = ({ user }) => {
  if (!user) return null;
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue("area", user?.area);
  }, [user]);

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 4,
        boxShadow: 4,
        background: "linear-gradient(145deg, #ffffff, #f9f9f9)",
        height: "100%",
      }}
    >
      <CardContent>
        {/* Profile Header */}
        <Box display="flex" alignItems="center" mb={3}>
          <Avatar
            src={user.profilePic}
            alt={user.fullName}
            sx={{
              width: 64,
              height: 64,
              bgcolor: "#1976d2",
              fontSize: 24,
              mr: 2,
            }}
          >
            {user.fullName?.[0].toUpperCase()}
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight="bold" color="text.primary">
              {user.fullName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.userName || "Customer"}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Info List */}

        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "transparent",
              p: 1.2,
              borderRadius: 2,
            }}
          >
            <Box sx={{ minWidth: 36, mr: 2 }}>
              <Email fontSize="small" color="primary" sx={{ mr: 1 }} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Email Id
              </Typography>
              <Typography variant="body2" fontWeight="500">
                {user.emailId || "Not Available"}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "grey.50",
              p: 1.2,
              borderRadius: 2,
            }}
          >
            <Box sx={{ minWidth: 36, mr: 2 }}>
              <Phone fontSize="small" color="success" sx={{ mr: 1 }} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Mobile No
              </Typography>
              <Typography variant="body2" fontWeight="500">
                {user.mobileNo || "Not Available"}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "grey.50",
              p: 1.2,
              borderRadius: 2,
            }}
          >
            <Box sx={{ minWidth: 36, mr: 2 }}>
              <Home fontSize="small" color="warning" sx={{ mr: 1 }} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Address
              </Typography>
              <Typography variant="body2" fontWeight="500">
                {user.address || "Not Available"}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "grey.50",
              p: 1.2,
              borderRadius: 2,
            }}
          >
            <Box sx={{ minWidth: 36, mr: 2 }}>
              <Person fontSize="small" color="info" sx={{ mr: 1 }} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Status
              </Typography>
              <Typography variant="body2" fontWeight="500">
                {user.status || "Not Available"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default UserDetails;
